import React, { useEffect, useState } from "react";

const LoadingScreen: React.FC = () => {
  const [count, setCount] = useState(30); // countdown seconds

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    const timer = setTimeout(() => {
      console.log("Auto reload triggered");
      window.location.reload();
    }, 30000); // auto reload after 30s

    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-900 text-white">
      {/* Loader */}
      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white"></div>

      {/* Message */}
      <span className="mt-4 text-lg">Loading App...</span>

      {/* Auto reload countdown */}
      <span className="mt-2 text-sm text-gray-400">
        Auto reloading in {count}
      </span>
    </div>
  );
};

export default LoadingScreen;
